import { Button, Typography, Box, Divider } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import styles from "./LoginRequired.module.scss";
import imageSrc from "Explore/Assets/call-to-login.webp";
import { forwardRef, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { login } from "Redux/Actions/Auth";

const LoginRequiredSection = forwardRef(
  ({ blur, className, setHeight, title }, propRef) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [simpleSection, setSimpleSection] = useState(false);
    // const containerRef = useRef(null);
    const _ref = useRef(null);
    const ref = propRef || _ref;
    useEffect(() => {
      const resizeObserver = new ResizeObserver(() => {
        const section = ref?.current;
        if (!section) return;
        const { width, height } = section.getBoundingClientRect();
        if (width < 520) {
          setSimpleSection(true);
        } else {
          setSimpleSection(false);
        }
        setHeight?.(height);
      });
      resizeObserver.observe(ref?.current);
      return () => {
        resizeObserver.disconnect();
      };
    }, [ref]);

    const handleLoginGoogle = useGoogleLogin({
      onSuccess: (codeResponse) => {
        dispatch(login(codeResponse));
      },
      onError: () => {
        return (
          <>Some thing went wrong. Please check your network connection.</>
        );
      },
    });

    return (
      <Box
        className={classNames(styles["container"], { [styles["blur"]]: blur })}
        ref={ref}
      >
        <Box
          className={classNames(styles["login-container"], className)}
        >
          {blur && <div className={styles["blur-cover"]} />}
          {
            !simpleSection && (<div className={styles["image-container"]}>
              <img
                src={imageSrc}
                alt="Login required"
                className={styles["top-image"]}
              />
            </div>
            )}


          <Box className={styles["content-container"]}>
            <Box className={styles["title-container"]}>
              <Typography variant="h5" className={styles["title"]}>
                {title ? title : simpleSection
                  ? "Login to view this section"
                  : "Create free account to unlock more features"}
              </Typography>
              {/* {!simpleSection && (
            <Typography variant="body1" className={styles["subtitle"]}>
              Login to view this section
            </Typography>
          )} */}
            </Box>

            <div
              className={classNames(styles["login-options"], {
                [styles["simple"]]: simpleSection,
              })}
            >
              <Box
                className={classNames(styles["third-party-options"], {
                  [styles["simple"]]: simpleSection,
                })}
              >
                <Button
                  variant="outlined"
                  startIcon={<GoogleIcon />}
                  fullWidth
                  className={styles["login-button"]}
                  onClick={() => {
                    handleLoginGoogle();
                  }}
                >
                  {!simpleSection && "Login with Google"}
                </Button>

                {/* <Button
                  variant="outlined"
                  startIcon={<FacebookIcon />}
                  fullWidth
                  className={styles["login-button"]}
                >
                  {!simpleSection && "Login with Facebook"}
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<LinkedInIcon />}
                  fullWidth
                  className={styles["login-button"]}
                >
                  {!simpleSection && "Login with LinkedIn"}
                </Button> */}
              </Box>

              <Divider className={styles["divider"]}>
                <Typography variant="body2" color="textSecondary">
                  OR
                </Typography>
              </Divider>

              <Button
                variant="contained"
                startIcon={<AccountCircleIcon />}
                fullWidth
                className={styles["login-button"]}
                color="primary"
                onClick={() => {
                  navigate(`/login`, {
                    state: {
                      previousPage: location.pathname + location.search,
                    },
                  });
                }}
              >
                Use Admin Account
              </Button>
            </div>
          </Box>
        </Box>
      </Box>
    );
  }
);
export default LoginRequiredSection;
